import React from 'react';

import TimeEditableClass from 'notebook/protocols/editor/TimeEditable';
import TimeDisplay from 'notebook/protocols/viewer/TimeDisplay';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

import {EditHelpers} from '../timers/TimerConstants';

export interface InlineTimerDisplayProps {
  inlineCopy?: boolean;
  inProgress: boolean;
  msLeft: number;
  msTotal: number;
  resetTimer: (e: ElementMouseEvent) => void;
  startTimer: (e: ElementMouseEvent) => void;
  stopTimer: (e: ElementMouseEvent) => void;
  toggleStart: (e: ElementMouseEvent) => void;
  allowEdits?: boolean;
  editHelpers?: EditHelpers;
}

interface State {
  editing: boolean;
}

class InlineTimerDisplay extends React.Component<InlineTimerDisplayProps, State> {
  override state: State = {
    editing: false,
  };

  editTimer = (): void => {
    this.setState({editing: true}, () => {
      this.props.editHelpers!.setSelection!({
        start: 6,
        end: 6,
        cid: TimeEditableClass.computeCid(this.props.editHelpers!.cid),
      });
    });
  };

  finalizeTimer = (): void => {
    this.setState({editing: false});
  };

  renderProgress = (): null => null;

  override render(): JSX.Element {
    return (
      <span className="step-timer inline-step-timer">
        <TimeDisplay
          editing={this.state.editing}
          editHelpers={this.props.editHelpers}
          msLeft={this.props.msLeft}
          msTotal={this.props.msTotal}
          toggleStart={this.props.toggleStart}
          finalizeTimer={this.finalizeTimer}
          renderProgress={this.renderProgress}
        />
        <div className="time-controls">
          {this.state.editing ? (
            <a key="finalize" onClick={this.finalizeTimer}>
              <BenchlingIcon icon="check" />
            </a>
          ) : this.props.inProgress ? (
            <a onClick={this.props.stopTimer}>
              <BenchlingIcon icon="stop" />
            </a>
          ) : (
            [
              this.props.msLeft > 0 ? (
                <a key="start" onClick={this.props.startTimer}>
                  <BenchlingIcon icon="play" />
                </a>
              ) : undefined,
              this.props.msLeft < this.props.msTotal ? (
                <a key="reset" onClick={this.props.resetTimer}>
                  <BenchlingIcon icon="repeat" />
                </a>
              ) : undefined,
              this.props.allowEdits ? (
                <a key="edit" onClick={this.editTimer}>
                  <BenchlingIcon icon="edit" />
                </a>
              ) : undefined,
            ]
          )}
        </div>
      </span>
    );
  }
}

export default InlineTimerDisplay;
